/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IntervalPropertyBreakdownByZone,
    IntervalPropertyBreakdownByZoneFromJSON,
    IntervalPropertyBreakdownByZoneFromJSONTyped,
    IntervalPropertyBreakdownByZoneToJSON,
} from './IntervalPropertyBreakdownByZone';

/**
 * 
 * @export
 * @interface EmotionSummaryResponse
 */
export interface EmotionSummaryResponse {
    /**
     * 
     * @type {Array<IntervalPropertyBreakdownByZone>}
     * @memberof EmotionSummaryResponse
     */
    items: Array<IntervalPropertyBreakdownByZone>;
}

export function EmotionSummaryResponseFromJSON(json: any): EmotionSummaryResponse {
    return EmotionSummaryResponseFromJSONTyped(json, false);
}

export function EmotionSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmotionSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(IntervalPropertyBreakdownByZoneFromJSON)),
    };
}

export function EmotionSummaryResponseToJSON(value?: EmotionSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(IntervalPropertyBreakdownByZoneToJSON)),
    };
}

